import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { fetchNews, stripHtml, formatDate } from '../../lib/wordpress';
import type { WPPost } from '../../lib/wordpress';
import CommonHeader from '../../components/feature/CommonHeader';
import CommonFooter from '../../components/feature/CommonFooter';
import SeoHead from '../../components/feature/SeoHead';

const newsJsonLd = [
  {
    '@type': 'CollectionPage',
    '@id': 'https://saiwaidental.jp/moyuk/news/',
    url: 'https://saiwaidental.jp/moyuk/news/',
    name: 'お知らせ | さいわいデンタルクリニック moyuk SAPPORO 札幌',
    description: 'さいわいデンタルクリニック moyuk SAPPOROからのお知らせ・最新情報。',
    inLanguage: 'ja',
    isPartOf: { '@id': 'https://saiwaidental.jp/moyuk/#website' },
  },
  {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'TOP', item: 'https://saiwaidental.jp/moyuk/' },
      { '@type': 'ListItem', position: 2, name: 'お知らせ', item: 'https://saiwaidental.jp/moyuk/news/' },
    ],
  },
];

const BRAND = '#3E5F8F';

export default function NewsList() {
  const [posts, setPosts] = useState<WPPost[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchNews().then(setPosts).finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title="お知らせ | さいわいデンタルクリニック moyuk SAPPORO 札幌"
        description="さいわいデンタルクリニック moyuk SAPPOROからのお知らせ・最新情報。"
        canonical="https://saiwaidental.jp/moyuk/news/"
        ogSiteName="moyuk SAPPORO さいわいデンタル"
        ogLocale="ja_JP"
        twitterCard="summary_large_image"
        jsonLd={newsJsonLd}
      />
      <CommonHeader />

      <main className="pt-28 pb-24 px-6 max-w-3xl mx-auto">
        <div className="mb-10">
          <h1 className="text-3xl font-bold font-serif text-gray-900 mb-2">お知らせ｜さいわいデンタル 札幌</h1>
          <p className="text-gray-500 text-sm">さいわいデンタルクリニック moyuk SAPPOROからの最新情報</p>
        </div>

        {loading && (
          <div className="space-y-4">
            {[...Array(4)].map((_, i) => (
              <div key={i} className="h-20 bg-gray-100 rounded-lg animate-pulse" />
            ))}
          </div>
        )}

        {!loading && posts.length === 0 && (
          <p className="text-gray-400 text-center py-20">お知らせはありません</p>
        )}

        {!loading && posts.length > 0 && (
          <div className="divide-y divide-gray-100">
            {posts.map(post => (
              <Link
                key={post.id}
                to={`/news/${post.slug}/`}
                className="group flex items-start gap-4 py-5 hover:opacity-70 transition-opacity"
              >
                <time className="text-xs text-gray-400 whitespace-nowrap pt-0.5 w-24 shrink-0">
                  {formatDate(post.date)}
                </time>
                <div>
                  <span
                    className="inline-block text-xs px-2 py-0.5 rounded text-white mb-1"
                    style={{ backgroundColor: BRAND }}
                  >
                    お知らせ
                  </span>
                  <p
                    className="text-sm font-medium text-gray-900 group-hover:opacity-70 transition-opacity"
                    dangerouslySetInnerHTML={{ __html: post.title.rendered }}
                  />
                </div>
              </Link>
            ))}
          </div>
        )}
      </main>

      <CommonFooter />
    </div>
  );
}
